const COLORS = {
	primary: '#8A54E8',
	mainTextColor: '#1E1E1E',
}

export default COLORS
